import React, { useRef } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ParticlesComp from "./components/ParticlesComp";
import AboutMe from "./components/About-Me";
import Technologies from "./components/Technologies.js";
import ProjectsComp from "./components/ProjectsComp";
import Contact from "./components/Contact";
import NavbarComp from "./components/NavbarComp";
import SpaceBackground from "./components/SpaceBackground";

function App() {
  const heroRef = useRef();
  const aboutRef = useRef();
  const skillsRef = useRef();
  const workRef = useRef();
  const contactRef = useRef();

  const scrollTo = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <SpaceBackground />
      <NavbarComp
        handleHome={() => scrollTo(heroRef)}
        handleAbout={() => scrollTo(aboutRef)}
        handleSkills={() => scrollTo(skillsRef)}
        handleWork={() => scrollTo(workRef)}
        handleContact={() => scrollTo(contactRef)}
      />
      <section ref={heroRef}>
        <ParticlesComp
          handleParticlesClick={() => scrollTo(aboutRef)}
        />
      </section>
      <section ref={aboutRef}>
        <AboutMe />
      </section>
      <section ref={skillsRef}>
        <Technologies />
      </section>
      <section ref={workRef}>
        <ProjectsComp />
      </section>
      <section ref={contactRef}>
        <Contact />
      </section>
    </div>
  );
}

export default App;
